export function matchedRoute(lang, route) {
  if (lang === 'ru') {
    return `${route}`;
  }
  return `/${lang}${route}`;
}
